import { Cable, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg copper-gradient flex items-center justify-center">
              <Cable className="w-4 h-4 text-white" />
            </div>
            <span className="font-display font-extrabold text-lg text-white">Cable<span className="text-[#D96B27]">Careers</span></span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Connecting Cable & Conductor Industry Talent with specialized manufacturers across India.</p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3 text-sm">Candidates</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/jobs" className="hover:text-[#D96B27]">Browse Jobs</Link></li>
            <li><Link to="/candidates" className="hover:text-[#D96B27]">Create Profile</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3 text-sm">Employers</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/employers" className="hover:text-[#D96B27]">Post a Job</Link></li>
            <li><Link to="/employer/dashboard" className="hover:text-[#D96B27]">Search Talent</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3 text-sm">Sectors</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>HT / EHT Power Cables</li>
            <li>ACSR / AAAC Conductors</li>
            <li>Wire Drawing & Stranding</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 mb-2 text-sm">
          <a href="mailto:omptiwari1954@gmail.com" data-testid="footer-email" className="flex items-center gap-1.5 text-slate-300 hover:text-[#D96B27] transition-colors"><Mail className="w-3.5 h-3.5" />omptiwari1954@gmail.com</a>
          <a href="tel:+919904285444" data-testid="footer-phone" className="flex items-center gap-1.5 text-slate-300 hover:text-[#D96B27] transition-colors"><Phone className="w-3.5 h-3.5" />+91 99042 85444</a>
        </div>
        © 2026 CableCareers. Built for the Cable, Wire & Conductor Manufacturing Industry. (cablecareers.in)
        <span className="mx-2">·</span>
        Powered by <a href="https://www.codeanapple.com/" target="_blank" rel="noreferrer" data-testid="footer-powered-by" className="text-[#D96B27] hover:underline font-medium">CodeAnApple</a>
      </div>
    </footer>
  );
}
